import { render, staticRenderFns } from "./PesquisaAvancada.vue?vue&type=template&id=fcf37a92"
import script from "./PesquisaAvancada.vue?vue&type=script&lang=js"
export * from "./PesquisaAvancada.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAvancada.vue?vue&type=style&index=0&id=fcf37a92&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports